import React from "react";
import { Amount } from "@design-system/Amount/Amount";
import { TransactionAllocationRow } from "./multiAllocationHelpers";
import styles from "../EditAllocationDrawer.module.scss";

interface Props {
    readonly rows: TransactionAllocationRow[];
    readonly getLabel: (transactionId: number) => string;
}

export const UnbalancedTransactionsSummary: React.FC<Props> = ({
    rows,
    getLabel,
}) => {
    if (rows.length === 0) {
        return null;
    }
    return (
        <div className={styles.summaryArea}>
            <div className={styles.summaryRow}>
                <span className={styles.summaryLabel}>
                    Allocated vs. transaction amount
                </span>
            </div>
            {rows.map((row) => (
                <div key={row.transactionId} className={styles.summaryRow}>
                    <span className={styles.summaryLabel}>
                        {getLabel(row.transactionId)}
                    </span>
                    <span className={styles.summaryValue}>
                        <Amount amount={row.allocated} /> of{" "}
                        <Amount amount={row.amount} />
                    </span>
                </div>
            ))}
        </div>
    );
};
